module.exports = __webpack_public_path__ + "img/aej1n-66wvl.005.f22e19f6.png";